import { ROUTE_GAME, ROUTE_MULTIBET } from '@/models/Route';
import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

export const useIsLobby = () => {
    const location = useLocation();
    const isLobby = useMemo(
        () =>
            location.pathname !== ROUTE_MULTIBET &&
            location.pathname.indexOf(ROUTE_GAME) < 0,
        [location.pathname]
    );
    return isLobby;
};
